<template>
  <div>
    <el-form-item
      v-if="!sqlDlg"
      :label="sqlLabel"
      :prop="index === null ? sqlField : 'tabs.' + index + '.' + sqlField"
      :rules="[{ required: true, message: '请输入sql', trigger: 'change' }]"
    >
      <el-input v-model="standardForm[sqlField]" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea" readonly></el-input>
      <el-button type="text" @click="showDlg">编辑</el-button>
    </el-form-item>
    <el-form-item
      v-if="sqlDlg"
      :label="sqlLabel"
      :prop="index === null ? sqlField : 'tabs.' + index + '.' + sqlField"
      :rules="[{ required: true, message: '请输入sql', trigger: 'change' }]"
    >
      <codemirror ref="jsonEditorInter" v-model="standardForm[sqlField]" class="codemirror" :options="cmOptions" />
    </el-form-item>
    <el-form-item :label="orderExprLabel">
      <el-input v-model="standardForm[orderExprField]" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" maxlength="200" />
    </el-form-item>
    <el-dialog
      v-dialogDrag
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="920px"
      :before-close="handleClose"
      append-to-body
    >
      <codemirror ref="jsonEditor" v-model="sql" class="codemirror" :options="cmOptions" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/sql/sql.js";
// 替换主题这里需修改名称
import "codemirror/theme/idea.css";
import "codemirror/theme/xq-light.css";
import "codemirror/mode/sql/sql.js";
// 加提示的引用
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/sql-hint";
import "codemirror/addon/hint/show-hint";
export default {
  components: { codemirror },

  props: {
    sqlDlg: {
      type: Boolean,
      default() {
        return true;
      }
    },
    standardForm: {
      type: Object,
      default() {
        return {};
      }
    },
    sqlField: {
      type: String,
      default: "sql"
    },
    sqlLabel: {
      type: String,
      default: "sql"
    },
    orderExprField: {
      type: String,
      default: "orderExpr"
    },
    orderExprLabel: {
      type: String,
      default: "sql排序"
    },
    title: {
      type: String,
      default: "orderExpr"
    },
    index: {
      type: Number || NULL,
      default: null
    }
  },
  data() {
    return {
      cmOptions: {
        tabSize: 4,
        mode: "text/x-sql",
        theme: "xq-light",
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        matchBrackets: true, // 括号匹配
        lineWrapping: true,
        // 加提示
        hintOptions: {
          completeSingle: false
        }
      },
      dialogVisible: false,
      sql: ""
    };
  },
  methods: {
    showDlg() {
      this.sql = this.standardForm[this.sqlField];
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.sql = "";
    },
    handleConfirm() {
      this.standardForm[this.sqlField] = this.sql;
      this.handleClose();
    }
  }
};
</script>

<style lang="less" scoped>
.codemirror {
  line-height: 20px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
